export default [
  {
    path: "/dokuman-takip/listesi",
    name: "dokuman-takip-listesi",
    component: () => import("./index.vue"),
    meta: {
      pageTitle: "Döküman Listesi",
      breadcrumb: [
        {
          title: "dokuman_takip.Döküman Takip",
          to: { name: "dokuman-takip-listesi" },
        },
        {
          title: "Liste",
          active: true,
        },
      ],
      yetki: { k: [1023002] },
    },
  },
  {
    path: "/dokuman-takip/kategoriler",
    name: "dokuman-takip-kategoriler",
    component: () => import("./kategoriler.vue"),
    meta: {
      pageTitle: "dokuman_takip.Kategori Yönetimi",
      breadcrumb: [
        {
          title: "dokuman_takip.Döküman Takip",
          to: { name: "dokuman-takip-listesi" },
        },
        {
          title: "Kategoriler",
          active: true,
        },
      ],
      yetki: { k: [1023002] },
    },
  },
  {
    path: "/dokuman-takip/bilgi-bankasi",
    name: "dokuman-takip-bilgi-bankasi",
    component: () => import("./BelgeBilgiBankasi.vue"),
    meta: {
      pageTitle: "dokuman_takip.Belge Bilgi Bankası",
      breadcrumb: [
        {
          title: "dokuman_takip.Döküman Takip",
          to: { name: "dokuman-takip-listesi" },
        },
        {
          title: "dokuman_takip.Belge Bilgi Bankası",
          active: true,
        },
      ],
      yetki: { k: [1023012] },
    },
  },
]
